import React from 'react'
import OnVisible from 'react-on-visible'
import { Section } from 'newComponents'
import './styles.scss'

const Table = (props) => {
  const { data, location } = props
  const { primary } = data
  const { table } = primary
  const tableHtml = table?.html

  const altRender = !location.pathname.includes('blog') ? 'page-variant' : ''

  return (
    <OnVisible className={`table-embed ${altRender}`}>
      <Section className="table-embed-section">
        <div className="table-embed-container">
          {tableHtml && (
            <div
              className="table-embed-container-content"
              dangerouslySetInnerHTML={{
                __html: tableHtml
              }}
            />
          )}
        </div>
      </Section>
    </OnVisible>
  )
}

export default Table
